module.exports = __webpack_public_path__ + "static/logo-6e468497bcffaa43eb36db43f810d444.jpg";